import { Component, Inject } from '@angular/core';
import { PhoneVerifyComponent } from '../phone-verify/phone-verify.component';
import { MAT_DIALOG_DATA, } from '@angular/material/dialog';

@Component({
  selector: 'app-phone-verify-modal',
  standalone: true,
  imports: [PhoneVerifyComponent],
  templateUrl: './phone-verify-modal.component.html',
  styleUrl: './phone-verify-modal.component.scss'
})
export class PhoneVerifyModalComponent {

  public isRegister: boolean;
  public user_id: string;
  public phone: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { isRegister: boolean, user_id: string, phone?: string }
  ) {
    this.isRegister = data.isRegister;
    this.user_id = data.user_id;
    this.phone = data.phone ?? '';
  }

}
